import React, { memo, useState } from 'react';
import styles from './GameCard.module.less';
import Config from '../../config';
import { debounce, stubArray } from 'lodash-es';
import { getGameList } from '../../../../actions/order';
import { useDispatch, useSelector } from 'react-redux';
import Toast from '../../../../components/Toast/Toast';
import Default from '../../../../static/refund_default.svg';
import icon from '../../../../static/refund_icon.svg';
import { logging, logPostInfo } from '../../../../actions/log';
import { createSelector } from 'reselect';
import Dialog from '../../../../components/Dialog/Dialog';

const lineInfo = [
  { id: 1, name: 'orderId', cnName: '订单号', info: '' },
  { id: 2, name: 'payTime', cnName: '支付时间', info: '' },
  { id: 3, name: 'payAmount', cnName: '支付金额', info: '' },
  { id: 4, name: 'refundStatus', cnName: '订单状态', info: '' },
];

const refundList = {
  0: '支付成功',
  1: '退款中，预计2-3个工作日到账，恰逢周末及节假日将顺延',
  2: '已退款成功',
};

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

let Page_GameOrder_Loading = 0;
export default memo(({ info }) => {
  const dispatch = useDispatch();
  const [showReason, setShowReason] = useState(false);
  const [validImg, setValidImg] = useState(info.gameIconUrl);
  const logInfoData = useSelector(selectLogInfo);
  const [visible, setVisible] = useState(false);

  const gameOrderRefund = async () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Store_Refund',
        label: '',
        param2: {
          source: 'Game_Orders',
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
          id: info.orderId,
        },
      }),
    );
    if (Page_GameOrder_Loading !== 1) {
      Page_GameOrder_Loading = 1;

      let data = await Config.gameRefund({ orderId: info.orderId });
      if (data.status === 0) {
        Page_GameOrder_Loading = 0;
        Toast.success({ content: '提交退款成功' });
        // dispatch(getGameList({ page: 1, size: 24, refresh: true }));
      } else {
        Page_GameOrder_Loading = 0;
        if (data.status === -7 || data.status === -8 || data.status === -9) {
          Toast.error({ content: data.message });
        } else {
          Toast.error({ content: '提交退款失败' });
        }
      }
    }
    dispatch(getGameList({ page: 1, size: 24, refresh: true }));
    setVisible(false);
  };

  const handleCancelModal = info => {
    setVisible(false);
    if (info) {
      dispatch(
        logging({
          category: 'C',
          action: 'Store_Refund_Cancel',
          label: '',
          param2: {
            source: 'Game_Orders',
            source_p: logInfoData.source,
            source_pp: logInfoData.source_p,
            id: info.orderId,
          },
        }),
      );
    }
  };

  const showRefund = () => {
    setVisible(true);

    dispatch(
      logging({
        category: 'P',
        action: 'Store_Refund',
        label: '',
        param2: {
          source: 'Game_Orders',
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
          id: info.orderId,
        },
      }),
    );
  };

  return (
    <div className={styles.mall_orders_card}>
      <div className={styles.card_header}>
        <div className={styles.card_name}>
          <div className={styles.name_icon}>
            <img src={validImg ?? Default} onError={() => setValidImg(Default)} />
          </div>
          <div className={styles.mall_name}>
            <div className={styles.name}>{info.gameName}</div>

            {info.allowRefundFlag === 0 && (
              <div className={styles.no_reason}>
                <img src={icon} className={styles.reason_icon} />

                <div className={styles.reason}>{info.allowRefundDay}天无理由退换</div>
              </div>
            )}
          </div>
        </div>
        <div className={styles.card_btn}>
          {info.allowRefundFlag === 0 && info.refundStatus === 0 && (
            <div className={styles.btn} onClick={showRefund}>
              退款
            </div>
          )}

          {info.refundStatus === 0 && info.allowRefundFlag === 1 && (
            <div className={styles.sigh}>
              <i
                className="iconfont icon-toolbar_about"
                onMouseEnter={() => setShowReason(true)}
                onMouseLeave={() => setShowReason(false)}
              />
              {showReason && (
                <div className={styles.sigh_reason}>
                  <div className={styles.reason_info}>已超过无理由退款时间，暂不支持退款</div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <div className={styles.card_info}>
        {lineInfo.map(el => (
          <div key={el.id} className={styles.card_info_item}>
            {el.name !== 'refundStatus' && (
              <>
                {el.name === 'payAmount' ? (
                  <>
                    <div className={styles.info_item_name}>{el.cnName}</div>
                    <div className={styles.info_item_content}>{info[el.name] / 100}元</div>
                  </>
                ) : (
                  <>
                    <div className={styles.info_item_name}>{el.cnName}</div>
                    <div className={styles.info_item_content}>{info[el.name]}</div>
                  </>
                )}
              </>
            )}
            {el.name === 'refundStatus' && (
              <>
                <div className={styles.info_item_name}>{el.cnName}</div>
                <div className={styles.info_item_content}>{refundList[info[el.name]]}</div>
              </>
            )}
          </div>
        ))}
      </div>
      {visible && (
        <Dialog
          maskStyle={styles.mask}
          containerStyle={styles.containerStyle}
          handleClose={handleCancelModal}
          title="温馨提示"
        >
          <div className={styles.modal_content}>
            退款完成后您将无法登录游玩该游戏，如对退款遇到问题，您可以在右上角联系客服。
          </div>
          <div className={styles.modal_button}>
            <div className={styles.button} onClick={() => handleCancelModal(1)}>
              取消
            </div>
            <div className={styles.button_sub} onClick={gameOrderRefund}>
              确认退款
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
});
